import { Slot } from '@radix-ui/react-slot';
import { cva, cx, type VariantProps } from 'cva';
import { type ComponentProps, type FunctionComponent } from 'react';
import styles from './Button.module.css';

const variant = cva({
  defaultVariants: {
    intent: 'primary',
    size: 'medium',
  },
  variants: {
    intent: {
      link: styles.link,
      primary: cx(styles.button, styles.primary),
      secondary: cx(styles.button, styles.secondary),
    },
    size: {
      large: styles.large,
      medium: styles.medium,
      small: styles.small,
    },
  },
});

export type ButtonProps = ComponentProps<'button'> &
  VariantProps<typeof variant> & {
    asChild?: boolean;
  };

export const Button: FunctionComponent<ButtonProps> = ({
  asChild,
  className,
  intent,
  ref,
  size,
  type = 'button',
  ...props
}) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      className={variant({ className, intent, size })}
      ref={ref}
      type={type}
      {...props}
    />
  );
};
